import { render, staticRenderFns } from "./BookingContentStatusFailed.vue?vue&type=template&id=454e6ba6&scoped=true&"
import script from "./BookingContentStatusFailed.vue?vue&type=script&lang=js&"
export * from "./BookingContentStatusFailed.vue?vue&type=script&lang=js&"
import style0 from "./BookingContentStatusFailed.vue?vue&type=style&index=0&id=454e6ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e6ba6",
  null
  
)

export default component.exports